// Builds "<title> | 360 SynergyTech" for dynamic detail pages, shortening the
// record's own title at a word boundary so the full <title> stays within ~60
// characters (the length search engines typically display).
const BRAND = "360 SynergyTech";
const MAX_LENGTH = 60;

export function buildPageTitle(title) {
  const suffix = ` | ${BRAND}`;
  const clean = (title || "").replace(/\s+/g, " ").trim();
  if (!clean) return BRAND;
  const room = MAX_LENGTH - suffix.length;
  if (clean.length <= room) return clean + suffix;
  const cut = clean.slice(0, room - 1);
  const wordEnd = cut.lastIndexOf(" ");
  const base = (wordEnd > room * 0.5 ? cut.slice(0, wordEnd) : cut).replace(/[\s,;:\-–]+$/, "");
  return base + "…" + suffix;
}
